import type { TextField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Label } from '@onclicks/sharedcomponents/ui/Label'
import { Textarea as TextAreaComponent } from '@onclicks/sharedcomponents/ui/Textarea'
import React from 'react'

import { Error } from '@onclicks/sharedcomponents/FieldForm/Error'
import { Width } from '@onclicks/sharedcomponents/FieldForm/Width'

export const Textarea: React.FC<
  TextField & {
    errors: Partial<FieldErrorsImpl>
    placeholder?: string
    register: UseFormRegister<FieldValues>
    rows?: number
  }
> = ({ name, defaultValue, errors, label, placeholder, register, required, rows = 7, width }) => {
  return (
    <Width width={width} className="flex flex-col gap-2">
      <Label htmlFor={name} className="text-primary font-bold">
        {label}

        {required && (
          <span className="required">
            * <span className="sr-only">(required)</span>
          </span>
        )}
      </Label>

      <div className="gradient-border rounded-3xl min-h-35">
        <TextAreaComponent
          defaultValue={defaultValue}
          id={name}
          rows={rows}
          placeholder={placeholder}
          className="h-35 rounded-3xl border-0 bg-pink-200 text-primary placeholder:text-primary/60 focus-visible:ring-secondary/50 focus-visible:ring-offset-0"
          {...register(name, { required: required })}
        />
      </div>

      {errors[name] && <Error name={name} />}
    </Width>
  )
}
